import { AppTemplate } from './AppTemplate';

export default AppTemplate;
